import React from 'react';
import '../styles/App.css';
import { Routes, Route } from 'react-router-dom';
import SignUp from './SignUp';
import Login from './Login';
import Posts from './Posts';
import Post from './Post';
import ResetPassword from './ResetPassword';
import ResetPasswordVerify from './ResetPasswordVerify';
import UserActivationVerify from './UserActivationVerify';
import Profile from './Profile';
import Layout from './Layout';
import Discussions from './Discussions';
import Discussion from './Discussion';
import LandingPage from './LandingPage';
import Waitlist from './Waitlist';
import ContactUs from './ContactUs';
import { DemoProvider } from '../context/DemoContext';
// import NewMessage from './NewMessage';

const App = () => {
    return (
        <DemoProvider>
        <Routes>
            {/* Landing page */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/waitlist" element={<Waitlist />} />
            <Route path="/contact-us" element={<ContactUs />} />
            
            {/* Authentication routes - no layout */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password/verify" element={<ResetPasswordVerify />} />
            <Route path="/user-activation/verify" element={<UserActivationVerify />} />
            
            {/* Main app routes - with layout */}
            <Route path="/posts" element={<Layout />}>
                <Route index element={<Posts />} />
                <Route path="post/:id" element={<Post />} />
            </Route>
            
            {/* Discussion routes - with layout */}
            <Route path="/discussions" element={<Layout />}>
                <Route index element={<Discussions />} />
            </Route>
            <Route path="/discussion/:id" element={<Layout />}>
                <Route index element={<Discussion />} />
            </Route>
            
            {/* Main navigation routes - with layout */}
            <Route path="/profile" element={<Layout />}>
                <Route index element={<Profile />} />
            </Route>
            
        </Routes>
        </DemoProvider>
    );
};

export default App;
